module.exports = __webpack_public_path__ + "img/TruPath-4.21aa3fb5.jpg";